import { render, staticRenderFns } from "./ReporteRedenciones.vue?vue&type=template&id=1092bb96"
import script from "./ReporteRedenciones.vue?vue&type=script&lang=js"
export * from "./ReporteRedenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports